import React from "react";
import AppTheme from "../../../../service/app_config/AppTheme";
import { IconNormal } from "../../../../widget/common/ui/Icon";
import SessionStorage from "../../../../service/storage/SessionStorage";
import StorageKeys from "../../../../const/StorageKeys";
import UtilityHelper from "../../../../service/utilities/UtilityHelper";
import AppTranslation from "../../../../service/app_translation/AppTranslation";
import { ButtonSingle } from "../../../../widget/common/form/Button";

const ImageDocumentPreviewActions = (props: { isModal: boolean }) => {
  const isModal: boolean = props.isModal;

  let imageDocsSession: string =
    SessionStorage.getValue(StorageKeys.preview_image_document) || "";

  let fileUrl: string = "",
    fileName: string = "";
  if (UtilityHelper.isNotEmpty(imageDocsSession)) {
    const imageDoc: { title: string; url: string } =
      JSON.parse(imageDocsSession);

    const urlArr: Array<string> = imageDoc?.url.split("/");
    fileUrl = imageDoc?.url;
    fileName = urlArr[urlArr.length - 1];
  }

  return (
    <>
      {UtilityHelper.isNotEmpty(fileUrl) && (
        <a
          href={fileUrl}
          download={fileName}
          target="_blank"
          rel="noopener noreferrer"
        >
          {isModal ? (
            <ButtonSingle width={250}>
              {AppTranslation.text("download")}
            </ButtonSingle>
          ) : (
            <IconNormal name="download" color={AppTheme.themeFont} />
          )}
        </a>
      )}
    </>
  );
};

export default ImageDocumentPreviewActions;
